if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.form = this.cartTermsCheckbox
        ? document.getElementById(this.cartTermsCheckbox.getAttribute('form'))
        : null;
      this.submitHandler = this.handleSubmit.bind(this);
      this.changeHandler = this.handleChange.bind(this);

      if (this.form) {
        this.form.addEventListener('submit', this.submitHandler);
      }

      if (this.cartTermsCheckbox) {
        this.cartTermsCheckbox.addEventListener('change', this.changeHandler);
        this.setButtonsDisabled(!this.cartTermsCheckbox.checked);
      } else {
        this.setButtonsDisabled(false);
      }
    }

    disconnectedCallback() {
      if (this.form) {
        this.form.removeEventListener('submit', this.submitHandler);
      }

      if (this.cartTermsCheckbox) {
        this.cartTermsCheckbox.removeEventListener('change', this.changeHandler);
      }
    }

    /**
     * Enable / disable checkout buttons
     * @param {boolean} isDisabled - Whether to disable buttons.
     */
    setButtonsDisabled(isDisabled) {
      if (!this.form) {
        return;
      }

      var formId = this.form.id;
      var buttonsInForm = this.form.querySelectorAll(
        'button[name="checkout"], .shopify-payment-button__button'
      );
      var selectorOutsideForm =
        'button[name="checkout"][form="' +
        formId +
        '"], .shopify-payment-button__button[form="' +
        formId +
        '"]';
      var buttonsWithFormAttr = document.querySelectorAll(selectorOutsideForm);

      var allButtons = [];
      Array.prototype.forEach.call(buttonsInForm, function (btn) {
        allButtons.push(btn);
      });
      Array.prototype.forEach.call(buttonsWithFormAttr, function (btn) {
        allButtons.push(btn);
      });

      Array.prototype.forEach.call(allButtons, function (button) {
        if (!button) {
          return;
        }
        button.disabled = isDisabled;
      });
    }

    /**
     * Handles cart terms checkbox change
     */
    handleChange() {
      if (!this.cartTermsCheckbox) {
        return;
      }

      this.setButtonsDisabled(!this.cartTermsCheckbox.checked);
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartTermsCheckbox || !this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        alert(theme.strings.cartTermsConfirmation); // eslint-disable-line
      }
    }
  }
  customElements.define('cart-terms', CartTerms);
}
